/**
 * DevExtreme (esm/__internal/events/m_visibility_change.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import eventsEngine from "../../common/core/events/core/events_engine";
import $ from "../../core/renderer";
const triggerVisibilityChangeEvent = function (eventName) {
  return function (element) {
    const $element = $(element || "body");
    const changeHandlers = $element.filter(".dx-visibility-change-handler").add($element.find(".dx-visibility-change-handler"));
    for (let i = 0; i < changeHandlers.length; i++) {
      eventsEngine.triggerHandler(changeHandlers[i], eventName);
    }
  };
};
export const triggerShownEvent = triggerVisibilityChangeEvent("dxshown");
export const triggerHidingEvent = triggerVisibilityChangeEvent("dxhiding");
export const triggerResizeEvent = triggerVisibilityChangeEvent("dxresize");
export default {
  triggerHidingEvent: triggerHidingEvent,
  triggerResizeEvent: triggerResizeEvent,
  triggerShownEvent: triggerShownEvent
};